var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.521,
    height: 30.521,
    viewBox: "0 0 30.521 30.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(-951.674 -140.674)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 15.261,
    cy: 15.261,
    r: 15.261,
    transform: "translate(951.674 140.674)",
    fill: "#4b0c11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(958.099 147.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M-4739.559,3215.271h17.608l-8.867-14.7Z",
    transform: "translate(4739.559 -3200.571)",
    fill: "none",
    stroke: "#ed1f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Warning_Warning",
    "data-name": "Warning / Warning",
    transform: "translate(8.804 5.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12,6v5.058m.026,1.723v.063H12v-.063Z",
    transform: "translate(-12 -6)",
    fill: "none",
    stroke: "#ed1f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.5fd7e381e5a1e1ac85506beb7bddc0e4.svg";
export { ForwardRef as ReactComponent };